import { render, staticRenderFns } from "./CreateCourseType.vue?vue&type=template&id=87acb340"
import script from "./CreateCourseType.vue?vue&type=script&lang=js"
export * from "./CreateCourseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports